module.exports = __webpack_public_path__ + "img/symbol_10.a2cfbe55.png";